import React, { useRef, useState } from "react";

export interface QuestionnaireWidgetV1Props {
    header: string;
    subHeader: string;
    answerSelectionMode?: string;
    answerOptions: string[];
    buttonText: string;
    redirectPath: string;
}

const lockIconUrl = "https://m.media-amazon.com/images/G/01/katara/Lock.png";
const privacyMessage = "Your health data is secure and protected by our practices and the law.";

const QuestionnaireWidgetV1 = (props: QuestionnaireWidgetV1Props) => {
    const header = props.header;
    const subHeader = props.subHeader;
    const isMultiSelection = props.answerSelectionMode === "MULTI_SELECT";
    const answerOptions = props.answerOptions;
    const buttonText = props.buttonText;
    const redirectPath = props.redirectPath;

    const selectorRef = useRef<any>(null);
    const [selectedAnswer, setSelectedAnswer] = useState<string>("");
    const [multipleAnswers, setMultipleAnswer] = useState<Array<String>> ([])
    const [buttonDisabled, setButtonDisabled] = useState<boolean>(true);
    const onSingleSelect = () => {
        // single select mode will return string as selected value.
        setSelectedAnswer(selectorRef.current.getSelectedValue());
        setButtonDisabled(false);
    };
    const onButtonClick = () => {
        window.location.href = redirectPath!
        return;
    };

    const onMultipleSelect = () => {
        // multi select mode will return array of string as selected value.
        const selectedValue = selectorRef.current.getSelectedValue();
        setMultipleAnswer(selectedValue);
        if (selectedValue === undefined || selectedValue.length <= 0) {
            setButtonDisabled(true);
        } else {
            setButtonDisabled(false);
        }
    };


    return (
        <pui-section className="content-container" pageContainer>
            <pui-section
                flowDirection="horizontal"
                mainAxisArrangement="space-between"
                secondaryAxisArrangement="center"
                spacingBottom="small"
            >
                <pui-section paddingBottom="small">
                    <pui-heading input={header} textSize="extra-large" class="warmup-heading" data-testid="page-header"></pui-heading>
                    {subHeader?.length > 0 && <pui-text input={subHeader} textSize="medium" spacingTop="small"></pui-text>}
                </pui-section>
            </pui-section>
            {isMultiSelection
                ? <pui-selector ref={selectorRef} multiselect >
                    {answerOptions?.map((answerOption) => (
                        <pui-selector-item
                            id={`ciq-warmup-answer-${encodeURIComponent(header!)}-${encodeURIComponent(answerOption!)}`}
                            key={answerOption}
                            initialValue={answerOption}
                            onClick={onMultipleSelect}
                            selected={multipleAnswers.find((value) => answerOption === value) ? 'true' : undefined}
                            hoverColor="light-grey"
                            showCheckbox
                            spacingTop="small"
                        >
                            <pui-text input={answerOption}></pui-text>
                        </pui-selector-item>
                    ))}
                </pui-selector>
                : <pui-selector ref={selectorRef} >
                    {answerOptions?.map((answerOption) => (
                        <pui-selector-item
                            id={`ciq-warmup-answer-${encodeURIComponent(header!)}-${encodeURIComponent(answerOption!)}`}
                            key={answerOption}
                            initialValue={answerOption}
                            onClick={onSingleSelect}
                            selected={selectedAnswer !== "" ? 'true' : undefined}
                            hoverColor="light-grey"
                            showRadioButton
                            spacingTop="small"
                        >
                            <pui-text input={answerOption}></pui-text>
                        </pui-selector-item>
                    ))}
                </pui-selector>
            }

            <pui-button
                id="clinic-ciq-warmup-widget-cta-btn"
                label={buttonText}
                onClick={onButtonClick}
                disabled={buttonDisabled ? 'true' : undefined}
                spacingTop="medium"
            ></pui-button>

            <pui-section flowDirection="horizontal" spacingTop="medium">
                <pui-section-column flexGrid="5">
                    <img src={lockIconUrl} width="21" height="21"/>
                </pui-section-column>
                <pui-section-column flexGrid="95">
                    <pui-text input={privacyMessage}></pui-text>
                </pui-section-column>
            </pui-section>
        </pui-section>
    );
}

export default QuestionnaireWidgetV1;
